import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../../services/analyticsService';
import cookieConsentService, { COOKIE_CONSENT_CHANGED_EVENT } from '../../services/cookieConsentService';

const AnalyticsTracker = () => {
  const location = useLocation();
  const lastPathRef = useRef('');
  const [analyticsEnabled, setAnalyticsEnabled] = useState(() => cookieConsentService.canUseCategory('analytics'));

  const sanitizePath = (path) => {
    if (path.startsWith('/verify-email/')) return '/verify-email/:token';
    if (path.startsWith('/newsletter/confirm/')) return '/newsletter/confirm/:token';
    if (path.startsWith('/newsletter/unsubscribe/')) return '/newsletter/unsubscribe/:token';
    return path;
  };

  useEffect(() => {
    const handleConsentChanged = (event) => {
      const nextEnabled = event?.detail?.preferences?.analytics === true;
      setAnalyticsEnabled(nextEnabled);
    };

    window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, handleConsentChanged);
    return () => {
      window.removeEventListener(COOKIE_CONSENT_CHANGED_EVENT, handleConsentChanged);
    };
  }, []);

  useEffect(() => {
    if (!analyticsEnabled) return;
    const nextPath = sanitizePath(location.pathname);
    if (nextPath === lastPathRef.current) return;
    lastPathRef.current = nextPath;
    analyticsService.trackVisit(nextPath);
  }, [analyticsEnabled, location.pathname]);

  return null;
};

export default AnalyticsTracker;
